import { Alert, Input, message, Modal } from "antd";
import React, { cloneElement, useState } from "react";
import { getGitBranch } from "../api/chat";
import { useCommonData } from "../../layout/ELayout";
import { useUserInfo } from "../../context/ThemeContext";

export default function IntroduceGitUrlModal(props: {
  children: JSX.Element;
  handleAddUrl?: (url: string) => void;
}) {
  const { handleAddUrl } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { commonData, changeCommonData } = useCommonData();
  const { userInfo, toggleUserInfo } = useUserInfo();
  const [url, setUrl] = useState("");
  const [inputStatus, setInputStatus] = useState<
    "" | "warning" | "error" | undefined
  >("");
  const btn = cloneElement(props.children, {
    onClick: () => {
      if (!checkLogin()) {
        return;
      }
      setIsOpen(true);
    },
  });
  const checkLogin = () => {
    const token = localStorage.getItem("token");
    if (!userInfo.login || !token) {
      changeCommonData({ showLogin: true });
      return false;
    }
    return true;
  };
  const handleOk = () => {
    if (inputStatus === "error") {
      return;
    }
    setIsOpen(false);
    handleAddUrl?.(url);
    setUrl("");
  };
  const handleCancel = () => {
    setIsOpen(false);
    setUrl("");
    setInputStatus("");
  };
  const inputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();
    setUrl(value);
    if (
      value.startsWith("http://github.com/") ||
      value.startsWith("https://github.com/")
      // value.startsWith("http://gitee.com/") ||
      // value.startsWith("https://gitee.com/")
    ) {
      setInputStatus("");
    } else {
      setInputStatus("error");
    }
  };
  return (
    <div>
      {btn}
      <Modal
        title="引入开源仓库"
        open={isOpen}
        centered
        okText="添加链接"
        cancelText="取消"
        width={600}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Alert
          message="目前仅支持公开的 GitHub 仓库，上传后使用默认分支代码回答你的问题"
          type="info"
          style={{ marginBottom: 16 }}
        />
        <Input
          value={url}
          status={inputStatus}
          onChange={inputChange}
          placeholder="输入Github链接"
        />
        {inputStatus === "error" && (
          <div style={{ color: "#ff4d4f" }}>
            暂不支持此类链接，换个链接试试呢
          </div>
        )}
      </Modal>
    </div>
  );
}
